'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  weekDayList: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  weekDay: {
    flex: '0 1 auto',
    width: 40,
    textAlign: 'center',
    padding: '10px 0 11px 0'
  },
  small: {
    '& $weekDay': {
      width: 24,
      padding: '2px 0 3px 0'
    }
  }
};